module.exports = __webpack_public_path__ + "img/color-googlecloud.cccaef2c.svg";